import {IDUSUARIO, customAxios} from '../constants';
import {serverError} from '../utils/actionError';

export * from './types';

// Actions
export * from './AreasVenta';
export * from './Autorizaciones';
export * from './AutorizacionesExcepcionales';
export * from './Clientes';
export * from './Colaboradores';
export * from './Colores';
export * from './Companias';
export * from './Condiciones';
export * from './EntregaFilial';
export * from './Estados';
export * from './Familias';
export * from './FichasVenta';
export * from './FacturacionElectronica';
export * from './Filiales';
export * from './Historial';
export * from './Marcas';
export * from './TipoVehiculo';//<88181>
export * from './Configuracion';//<88181>
export * from './Monedas';
export * from './Pedidos';
export * from './Proformas';
export * from './Tipos';
export * from './Usos';
export * from './Vendedores';
export * from './Zonas';
export * from './PlanificacionPedido';
export * from './Responsables';
export * from './MantenimientoEntrega';
export * from './MantenimientoSkuVehiculo';//<88181>
export * from './ArchivosAdjuntos';
export * from './Financiamiento';
export * from './Facturacion';
export * from './Capacitacion';
export * from './Inmatriculacion';
export * from './ProveedorCarrocero';
export * from './Sucursales';
export * from './EquiposLogistica';
export * from './EntidadFinanciera';
export * from './FormaPago';
export * from './TipoDocumento';
export * from './GestionCosto';
export * from './ProveedorEquiposAdicionales';
export * from './TipoAdicional';
export * from './Reporte';
export * from './EquiposCortesia';
export * from './MaestroGenerico';
export * from './ContactosClientesFacturacion';
export * from './PedidosColores';
export * from './SeguimientoAutorizaciones';
export * from './GenerarCorreoAutorizaciones';
export * from './AsginacionDefinitiva'
export * from './ReglasNegocio'
export * from './LogisticaCosto'
export * from './MantMaestro';
export * from './Permisos';
/*REQ-86365*/
export * from './SituacionAction';
/*REQ-86365*/
/*REQ-86367*/
export * from './EntregaAction';
/*REQ-86367*/

export const FETCH_FICHAS_ENTREGA = 'FETCH_FICHAS_ENTREGA';
export const LOADING_FICHAS_ENTREGA = 'LOADING_FICHAS_ENTREGA';
export const FETCH_FICHA_ENTREGA = 'FETCH_FICHA_ENTREGA';
export const LOADING_INMATRICULACION_CORREO = 'LOADING_INMATRICULACION_CORREO';
export const FETCH_INMATRICULACION_CORREO = 'FETCH_INMATRICULACION_CORREO';
export const FETCH_INMATRICULACION_DESCARGA= 'FETCH_INMATRICULACION_DESCARGA';

export const LOADING_INMATRICULACION_TITULO= 'LOADING_INMATRICULACION_TITULO';
export const FETCH_INMATRICULACION_TITULO = 'FETCH_INMATRICULACION_TITULO';
export const POST_INMATRICULACION_EXCEL= 'POST_INMATRICULACION_EXCEL';
export const POST_INMATRICULACION_PROCESAR= 'POST_INMATRICULACION_PROCESAR';
export const POST_INMATRICULACION_CORREO= 'POST_INMATRICULACION_CORREO';

export const CANT_X_PAG = 10;
export const PAG_1 = 1;
export const PAG_0 = 0;


export const FETCH_INDICADORES_ENTREGAS = 'FETCH_INDICADORES_ENTREGAS';
export const FETCH_FICHAS_ENTREGA_DESCARGAR = 'FETCH_FICHAS_ENTREGA_DESCARGAR';

const ENTREGAS_URL = process.env.REACT_APP_SID_ENTREGAS;
const STOCK_URL = process.env.REACT_APP_SID_STOCK;


export function fetchFichasEntrega(tipoProg = '', nropag = PAG_1, cantidadxpag = CANT_X_PAG, opcNum = 'npedido', numero = '',
                                   tipoFecha = 'fcc', fecha1 = '', fecha2 = '', codAreaVta = '', zonaCom = '', codFilial = '',
                                   cia = '', asesorCom = '', codMarca = '', baumauster = '', nomCliente = '', familia = '',
                                   estadoPedido = '', estadoPlan = '', estadoCan = '', transp = '', tipoPlaca = '', tipoEntrega = '', respEntrega = '', lugarEntrega = '') {
    const config = fetchFichasEntregaBase(tipoProg, nropag, cantidadxpag, opcNum, numero,
        tipoFecha, fecha1, fecha2, codAreaVta, zonaCom, codFilial,
        cia, asesorCom, codMarca, baumauster, nomCliente, familia,
        estadoPedido, estadoPlan, estadoCan, transp, tipoPlaca, tipoEntrega, 'S', '', respEntrega, lugarEntrega);


    const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo/planificaciones`, config)
        .catch(error => serverError(error, 'entrega'));

    return {
        type: FETCH_FICHAS_ENTREGA,
        payload: request,
    };
}

export function fetchFichasEntregaDescargar(tipoProg = '', nropag = PAG_1, cantidadxpag = CANT_X_PAG, opcNum = 'npedido', numero = '',
                                            tipoFecha = 'fcc', fecha1 = '', fecha2 = '', codAreaVta = '', zonaCom = '', codFilial = '',
                                            cia = '', asesorCom = '', codMarca = '', baumauster = '', nomCliente = '', familia = '',
                                            estadoPedido = '', estadoPlan = '', estadoCan = '', transp = '', tipoPlaca = '', tipoEntrega = '', respEntrega = '', lugarEntrega = '') {
    const config = fetchFichasEntregaBase(tipoProg, nropag, cantidadxpag, opcNum, numero,
        tipoFecha, fecha1, fecha2, codAreaVta, zonaCom, codFilial,
        cia, asesorCom, codMarca, baumauster, nomCliente, familia,
        estadoPedido, estadoPlan, estadoCan, transp, tipoPlaca, tipoEntrega, 'N', 'XLS', respEntrega, lugarEntrega);


    const request = customAxios.get(`${ENTREGAS_URL}/reporte/entrega`, config);

    return {
        type: FETCH_FICHAS_ENTREGA_DESCARGAR,
        payload: request,
    };
}

function fetchFichasEntregaBase(tipoProg, nropag, cantidadxpag, opcNum, numero,
                                tipoFecha, fecha1, fecha2, codAreaVta, zonaCom, codFilial,
                                cia, asesorCom, codMarca, baumauster, nomCliente, familia,
                                estadoPedido, estadoPlan, estadoCan, transp, tipoPlaca, tipoEntrega, indPaginado, tipoReporte, respEntrega, lugarEntrega) {
    let numPedido = '',
        numChasis = '',
        numFichaVta = '',
        numProforma = '';
    if (opcNum === 'npedido') {
        numPedido = numero;
    } else if (opcNum === 'nchasis') {
        numChasis = numero;
    } else if (opcNum === 'nfichaVenta') {
        numFichaVta = numero;
    } else if (opcNum === 'nproforma') {
        numProforma = numero;
    }

    let fecLogIni = '',
        fecLogFin = '',
        fecComIni = '',
        fecComFin = '',
        fecProIni = '',
        fecProFin = '',
        fecRecepIni = '',
        fecRecepFin = '';

    if (tipoFecha === 'fcc') {
        fecComIni = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
        fecComFin = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
    } else if (tipoFecha === 'fcl') {
        fecLogIni = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
        fecLogFin = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
    } else if (tipoFecha === 'fentregasprogra') {
        fecProIni = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
        fecProFin = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
    } else if (tipoFecha === 'frecepcionplacas') {
        fecRecepIni = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
        fecRecepFin = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
    }
    if (codAreaVta.length < 1) {
        codAreaVta = '';
    } else {
        codAreaVta = `[${codAreaVta}]`;
    }
    if (zonaCom.length < 1) {
        zonaCom = '';
    } else {
        zonaCom = `[${zonaCom}]`;
    }
    if (codFilial.length < 1) {
        codFilial = '';
    } else {
        codFilial = `[${codFilial}]`;
    }

    if (lugarEntrega.length < 1) {
        lugarEntrega = '';
    } else {
        lugarEntrega = `[${lugarEntrega}]`;
    }

    if (cia.length < 1) {
        cia = '';
    } else {
        cia = `[${cia}]`;
    }
    if (codMarca.length < 1) {
        codMarca = '';
    } else {
        codMarca = `[${codMarca}]`;
    }
    if (familia.length < 1) {
        familia = '';
    } else {
        familia = `[${familia}]`;
    }
    if (estadoPedido.length < 1) {
        estadoPedido = '';
    } else {
        estadoPedido = `[${estadoPedido}]`;
    }
    if (estadoPlan.length < 1) {
        estadoPlan = '';
    } else {
        estadoPlan = `[${estadoPlan}]`;
    }
    if (estadoCan.length < 1) {
        estadoCan = '';
    } else {
        estadoCan = `[${estadoCan}]`;
    }
    if (transp.length < 1) {
        transp = '';
    } else {
        transp = `[${transp}]`;
    }
    if (tipoPlaca.length < 1) {
        tipoPlaca = '';
    } else {
        tipoPlaca = `[${tipoPlaca}]`;
    }
    if (tipoEntrega.length < 1) {
        tipoEntrega = '';
    } else {
        tipoEntrega = `[${tipoEntrega}]`;
    }

    if (opcNum !== '') {
        numero = '';
    }

    const config = {
        params: {
            tipoProg,
            numPedido,
            numChasis,
            numFichaVta,
            numProforma,
            codAreaVta,
            zonaCom,
            codFilial,
            fecComIni,
            fecComFin,
            fecLogIni,
            fecLogFin,
            fecProIni,
            fecProFin,
            fecRecepIni,
            fecRecepFin,
            cia,
            asesorCom,
            codMarca,
            baumauster,
            nomCliente,
            familia,
            estadoPedido,
            estadoPlan,
            estadoCan,
            transp,
            tipoPlaca,
            tipoEntrega,
            tipoReporte,
            respEntrega,
            lugarEntrega
        },
        headers: {
            idUsuario: IDUSUARIO,
            indPaginado,
            nroPag: nropag,
            cantidadxPag: cantidadxpag,
        },
    };
    return config;
}


export function fetchFichaEntrega(id, tipoProg) {
    const config = {
        params: {
            codigo: id,
            tipoProg,
        },
        headers: {
            idUsuario: IDUSUARIO,
        },
    };

    const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo/planificaciones/${id}`, config);

    return {
        type: FETCH_FICHA_ENTREGA,
        payload: request,
    };
}

export function fetchInmatriculacionCorreo(params, paginaActual, cantidadPagina) {
    const config = {
        params: params,
        headers: {
            idUsuario: IDUSUARIO,
            nropag: paginaActual,
            cantidadxpag: cantidadPagina
        },
    };

    const request = customAxios.get(`${STOCK_URL}/envio-correo-archivo-xml/listar-correo`, config);

    return {
        type: FETCH_INMATRICULACION_CORREO,
        payload: request,
    };
}

export function fetchInmatriculacionCorreoDescarga(params) {
    const config = {
        params: params,
        headers: {
            idUsuario: IDUSUARIO,
            nropag: 1,
            cantidadxpag: 10000
        },
    };

    const request = customAxios.get(`${STOCK_URL}/envio-correo-archivo-xml/descargar-excel`, config);

    return {
        type: FETCH_INMATRICULACION_DESCARGA,
        payload: request,
    };
}

/*export function fetchInmatriculacionTitulo(params, paginaActual, cantidadPagina) {
    const config = {
        params: params,
        headers: {
            idUsuario: IDUSUARIO,
            nropag: paginaActual,
            cantidadxpag: cantidadPagina
        },
    };

    const request = customAxios.get(`${STOCK_URL}/envio-correo-archivo-xml/listar-correo`, config);

    return {
        type: FETCH_INMATRICULACION_TITULO,
        payload: request,
    };
}*/

export function postInmatriculacionExcel(data) {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
            'Content-Type': 'multipart/form-data'
        },
    };

    const request = customAxios.post(`${STOCK_URL}/envio-correo-archivo-xml/cargar-archivo`,data, config);

    return {
        type: POST_INMATRICULACION_EXCEL,
        payload: request,
    };
}

export function postInmatriculacionProcesar(data) {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
        },
    };

    const request = customAxios.post(`${STOCK_URL}/envio-correo-archivo-xml/procesar-archivo`,data, config);

    return {
        type: POST_INMATRICULACION_PROCESAR,
        payload: request,
    };
}

export function postInmatriculacionCorreo(data) {
    const config = {
        headers: {
            idUsuario: IDUSUARIO,
        },
    };

    const request = customAxios.post(`${STOCK_URL}/envio-correo-archivo-xml/enviar-correo`,data, config);

    return {
        type: POST_INMATRICULACION_CORREO,
        payload: request,
    };
}


export function loadFichasEntrega() {
    return {
        type: LOADING_FICHAS_ENTREGA,
    };
}

export function loadInmatriculacionCorreo() {
    return {
        type: LOADING_INMATRICULACION_CORREO,
    };
}

export function loadInmatriculacionTitulo() {
    return {
        type: LOADING_INMATRICULACION_TITULO,
    };
}

export function fetchIndicadoresEntregas(fechaIni, fechaFin) {
    const config = {
        params: {
            fechaIni,
            fechaFin,
        },
        headers: {
            idUsuario: IDUSUARIO,
        },
    };
    const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo/indicadores`, config);
    return {
        type: FETCH_INDICADORES_ENTREGAS,
        payload: request,
    };
}



// WEBPACK FOOTER //
// ./src/actions/index.js